import React from 'react'
import { Banner } from '../components/template'
const ContactUs = () => {
  return (
    <div>    <Banner/>
</div>
  )
}

export default ContactUs